import {kmUrl} from "./read_environment_variables";

/**
 * returns a link specific to Gethome branded Konto Mieszkaniowe
 */
export const getKMGHLink = (getAppLink: (params: {site: string}) => string): string => kmUrl + getAppLink({site: "gethome"});
